import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Input, Button, } from "reactstrap";
const BuilderModal = ({ isOpen, toggle, selected, onSave, }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
  });

  useEffect(() => {
    if (selected) {
      setForm({
        name: selected.name || "",
        phone: selected.phone || "",
        email: selected.email || "",
      });
    } else {
      setForm({
        name: "",
        phone: "",
        email: "",
      });
    }
  }, [selected]);

  const handleSubmit = async () => {
    if (!form.name) return alert("Name required");

    if (selected) {
      await onSave(selected._id, form);
    } else {
      await onSave(form);
    }
    setForm({
      name:"",
      phone:"",
      email:"",
    });

    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {selected ? "Edit Builder" : "Add Builder"}
      </ModalHeader>

      <ModalBody>
        <Input
          placeholder="Builder Name"
          className="mb-2"
          value={form.name}
          onChange={(e) =>
            setForm({ ...form, name: e.target.value })
          }
        />

        <Input
          placeholder="Phone"
          className="mb-2"
          value={form.phone}
          onChange={(e) =>
            setForm({ ...form, phone: e.target.value })
          }
        />

        <Input
          placeholder="Email"
          className="mb-3"
          value={form.email}
          onChange={(e) =>
            setForm({ ...form, email: e.target.value })
          }
        />

        <Button color="primary" onClick={handleSubmit}>
          Save
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default BuilderModal;